var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c("div", { staticStyle: { width: "70%" } }, [
            !_vm.precoOriginal && _vm.precoLabel
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      "line-height": "14px",
                      display: "block",
                    },
                  },
                  [_vm._v(_vm._s(_vm.precoLabel))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.precoOriginal
              ? _c("span", { staticClass: "preco-original" }, [
                  _vm._v(_vm._s(_vm.precoOriginal)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h2", { style: { color: _vm.corPrimaria } }, [
              _vm._v("\n          " + _vm._s(_vm.preco) + "\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "30%",
                "text-align": "right",
                "font-size": "12px",
                color: "#A8A8A8",
              },
            },
            [
              _vm.isDiscount
                ? _c("span", [_vm._v("À vista")])
                : _vm.maxInstalments > 1 && _vm.showInstalment
                ? _c("span", [
                    _vm._v(
                      "Em até " + _vm._s(_vm.maxInstalments) + "x no cartão"
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body" },
      [
        _vm.calendarMode
          ? _c("input-data-calendario", {
              attrs: {
                "passeio-id": _vm.passeioId,
                "initial-available-days": _vm.initialAvailableDays,
                "calendar-size": _vm.calendarSize,
              },
              on: { "on-open-change": _vm.calendarOpened },
              model: {
                value: _vm.selectedDate,
                callback: function ($$v) {
                  _vm.selectedDate = $$v
                },
                expression: "selectedDate",
              },
            })
          : _c("input-data-list", {
              attrs: {
                "available-days": _vm.initialAvailableDays,
                "passeio-id": _vm.passeioId,
                "return-days": _vm.returnDays,
                "primary-color": _vm.corPrimaria,
              },
              on: { "on-height-change": _vm.listHeightChanged },
              model: {
                value: _vm.selectedDate,
                callback: function ($$v) {
                  _vm.selectedDate = $$v
                },
                expression: "selectedDate",
              },
            }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loadingAvailability,
                expression: "loadingAvailability",
              },
            ],
            staticStyle: { "text-align": "center", "margin-top": "10px" },
          },
          [_c("i", { staticClass: "fa-regular fa-hourglass" })]
        ),
        _vm._v(" "),
        _c("input-tickets", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingAvailability && _vm.selectedDate,
              expression: "!loadingAvailability && selectedDate",
            },
          ],
          staticStyle: { "margin-top": "20px" },
          attrs: {
            options: _vm.ageRanges,
            "selected-date": _vm.selectedDate,
            "primary-color": _vm.corPrimaria,
            min: _vm.quantidadeMinVenda,
            max: _vm.quantidadeMaxVenda,
            "nome-item": _vm.$props.nomeItem,
            moeda: _vm.$props.moeda,
          },
          on: {
            "on-options-open-state-change": _vm.ageRangeOpened,
            "on-complience-state-change": _vm.complienceChange,
          },
          model: {
            value: _vm.selectedAgeRanges,
            callback: function ($$v) {
              _vm.selectedAgeRanges = $$v
            },
            expression: "selectedAgeRanges",
          },
        }),
        _vm._v(" "),
        _c("input-horario", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingAvailability && _vm.selectedDate,
              expression: "!loadingAvailability && selectedDate",
            },
          ],
          staticStyle: { "margin-top": "20px" },
          attrs: {
            horarios: _vm.horarios,
            "selected-quantities": _vm.selectedAgeRanges,
            "primary-color": _vm.corPrimaria,
            "show-remaining-vacancies": _vm.showRemainingVacancies,
            "passeio-tipo": _vm.tipoPasseio,
            "titulo-atividade": _vm.tituloAtividade,
            "genero-titulo-atividade": _vm.generoTituloAtividade,
          },
          model: {
            value: _vm.selectedAvailability,
            callback: function ($$v) {
              _vm.selectedAvailability = $$v
            },
            expression: "selectedAvailability",
          },
        }),
        _vm._v(" "),
        _c("input-opcionais", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.nPessoas > 0,
              expression: "nPessoas > 0",
            },
          ],
          staticStyle: { "margin-top": "20px" },
          attrs: {
            "selected-date": _vm.selectedDate,
            max: _vm.nPessoas,
            "primary-color": _vm.corPrimaria,
            "mobile-mode": false,
            "passeio-id": parseInt(_vm.passeioId),
            moeda: _vm.$props.moeda,
          },
          on: {
            "optionals-availability-change": (av) =>
              (_vm.hasOptionalsAvailable = av),
          },
          model: {
            value: _vm.selectedOptionals,
            callback: function ($$v) {
              _vm.selectedOptionals = $$v
            },
            expression: "selectedOptionals",
          },
        }),
        _vm._v(" "),
        _c("submit-button", {
          staticStyle: { "margin-top": "10px" },
          attrs: {
            disabled: !_vm.isReady,
            "is-loading": _vm.isSubmitting,
            label: _vm.buttonLabel,
            "primary-color": _vm.corPrimaria,
          },
          on: { click: _vm.submit },
        }),
        _vm._v(" "),
        _vm.$props.hasPaymentPartial
          ? _c("alerta-pagamento-parcial", {
              attrs: {
                "preco-parcial-label": _vm.$props.precoParcial,
                "porcentagem-parcial": _vm.$props.porcentagemParcial,
                total: _vm.subtotal + _vm.totalOpcionais,
                moeda: _vm.$props.moeda,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.descontoPeriodo > 0 || _vm.hasOptionalsAvailable
          ? _c("resumo-compra", {
              staticStyle: { "margin-top": "25px" },
              attrs: {
                total: _vm.totalSemDesconto,
                opcionais: _vm.totalOpcionais,
                desconto: _vm.descontoPeriodo,
                moeda: _vm.$props.moeda,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c(
        "strong",
        {
          key: "subtotal_" + _vm.subtotal,
          staticStyle: { visibility: "hidden", display: "block" },
          style: { visibility: _vm.isMounted ? "visible" : "hidden" },
        },
        [
          _vm._v(
            "Subtotal: " +
              _vm._s(_vm.formatMoney(_vm.subtotal + _vm.totalOpcionais))
          ),
        ]
      ),
      _vm._v(" "),
      _vm.$props.discountByPaymentMethod
        ? _c(
            "span",
            {
              key: "totalDesconto_" + _vm.totalDesconto,
              staticStyle: { display: "none", color: "#2FB97A" },
              style: {
                display:
                  _vm.isMounted && _vm.totalDesconto < _vm.subtotal
                    ? "block"
                    : "none",
              },
            },
            [
              _vm._v(
                "Pagando no " +
                  _vm._s(_vm.discountPaymentMethodsLabel || "Pix") +
                  ": " +
                  _vm._s(
                    _vm.formatMoney(_vm.totalDesconto + _vm.totalOpcionais)
                  )
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }